import script from "./RPTaxCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RPTaxCard.vue?vue&type=script&setup=true&lang=js"

import "./RPTaxCard.vue?vue&type=style&index=0&id=43111932&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43111932"]])

export default __exports__